['turbo:frame-load', 'turbo:load'].forEach(function(ev) {
  document.addEventListener(ev, function(e) {

    /* --------------------------------------------------
                  Shared modal open/close (used by init and URL param)
    -------------------------------------------------- */
    function openModalElement(modal) {
      const modalContent = modal.querySelector('[data-js="modal"]');
      const modalId = modal.id.replace('modal-', '');

      document.body.style.overflow = 'hidden';
      modal.classList.remove('hidden');
      modal.setAttribute('aria-hidden', 'false');
      if (modalContent) modalContent.focus();

      const handleEscapeKey = function(e) {
        if (e.key === 'Escape') closeModalElement(modal);
      };
      modal.addEventListener('keydown', handleEscapeKey);
      modal._escapeHandler = handleEscapeKey;

      modal.dispatchEvent(new CustomEvent('modal:opened', { bubbles: true, detail: { id: modalId } }));
    }

    function closeModalElement(modal) {
      modal.classList.add('hidden');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = 'auto';
      if (modal._escapeHandler) {
        modal.removeEventListener('keydown', modal._escapeHandler);
        delete modal._escapeHandler;
      }
      const modalId = modal.id.replace('modal-', '');
      modal.dispatchEvent(new CustomEvent('modal:closed', { bubbles: true, detail: { id: modalId } }));
    }

    /* --------------------------------------------------
                  Init
    -------------------------------------------------- */
    const cmpModalInit = function(){
      const modals = document.querySelectorAll('[data-js="modal-container"]');

      modals.forEach(modal => {
        const openTriggers = document.querySelectorAll(`[data-js="modal-open"][data-id="${modal.id.replace('modal-', '')}"]`);
        const closeTriggers = modal.querySelectorAll('[data-js="modal-close"]');
        const backdrop = modal.querySelector('[data-js="modal-backdrop"]');
        const modalScroll = modal.querySelector('[data-js="modal-scroll"]');

        function handleBackdropClick(e) {
          if (e.target === backdrop || e.target === modalScroll) {
            closeModalElement(modal);
          }
        }

        openTriggers.forEach(trigger => {
          trigger.addEventListener('click', (e) => {
            let currentTarget = e.currentTarget;
            if (!currentTarget || currentTarget.dataset.turbo !== "true") {
              e.preventDefault();
            }
            const parentModal = currentTarget && currentTarget.closest('[data-js="modal-container"]:not(.hidden)');
            if (parentModal && parentModal !== modal) {
              closeModalElement(parentModal);
            }
            openModalElement(modal);
          });
        });

        closeTriggers.forEach(trigger => {
          trigger.addEventListener('click', (e) => {
            e.preventDefault();
            closeModalElement(modal);
          });
        });

        backdrop.addEventListener('click', handleBackdropClick);
        modalScroll.addEventListener('click', handleBackdropClick);
      });
    }

    /* --------------------------------------------------
                  Auto-open modal from URL param
    -------------------------------------------------- */
    function autoOpenModalFromParam() {
      const params = new URLSearchParams(window.location.search)
      const modalId = params.get('open_modal')
      if (!modalId) return

      const modal = document.getElementById(`modal-${modalId}`)
      if (modal) {
        openModalElement(modal);
        params.delete('open_modal')
        const newUrl = params.toString()
          ? `${window.location.pathname}?${params}`
          : window.location.pathname
        history.replaceState(null, '', newUrl)
      }
    }

    /* --------------------------------------------------
                  Functions
    -------------------------------------------------- */
    cmpModalInit();
    autoOpenModalFromParam();
  });
})
